import { Injectable } from '@angular/core';
import { DashboardService } from '../home/dashboard.service';

@Injectable({
  providedIn: 'root'
})
export class AppService {


  private _businessUnitId: any;
  public get businessUnitId(): any {
    return this._businessUnitId;
  }
  public set businessUnitId(value: any) {
    this._businessUnitId = value;
  }

  // removed all CustomTitle references because not being used anywhere

  public _currentActivatedFeature: any = {
    'parentTitle': '',
    'parentRoute': '',
    'childTitle': '',
    'childRoute': '',
    'strategyId': ''
  };

  public get currentActivatedFeature(): any {
    return this._currentActivatedFeature;
  }

  public set currentActivatedFeature(value: any) {
    this.dashboardService.getAccountDetails();
    this.strategyId = value?.strategyId;
    this._currentActivatedFeature = value;
  }

  constructor(private dashboardService: DashboardService) {
    this.dashboardService.getAccountDetails();
  }

  public strategyId: string = '';
}
